import { useTranslation } from 'react-i18next';
import { Row, Col, Space, Typography } from 'antd';
import { BenefitItems } from 'all-in-one-shared-api';
import { getNameLabel, getRemarkLabel } from 'pages/benefits/utils/utils';
import { GreyInfoIcon, GreyText } from '../styledComponent';
import { FullWidthSpace } from 'components';

const { Text } = Typography;

interface AccordionTitleProps {
  benefit: BenefitItems;
}

const AccordionTitle = ({ benefit }: AccordionTitleProps): JSX.Element => {
  const { i18n } = useTranslation();

  const name = getNameLabel(i18n.language, benefit);
  const referralMark = getRemarkLabel(i18n.language, benefit);

  return (
    <FullWidthSpace direction="vertical">
      <Row>
        <Space>
          <GreyText>{benefit.id}</GreyText>
          <Text strong>{name}</Text>
        </Space>
      </Row>
      {referralMark && (
        <Row>
          <Col offset={1}>
            <Space>
              <GreyInfoIcon />
              <GreyText>{referralMark}</GreyText>
            </Space>
          </Col>
        </Row>
      )}
    </FullWidthSpace>
  );
};

export default AccordionTitle;
